/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CollaborationByMonthDTO,
  CollaborationSummaryDTO,
  ErrorResponse,
  QuoteDetailDTO,
  QuoteStatusByCompanyDTO,
  QuoteSupplierRequesterDTO,
  QuotesByCompanyDTO,
  QuotesByMonthDTO,
  RequestDetailDTO,
  RequestStatusByCompanyDTO,
  RequestsByCompanyDTO,
  RequestsByMonthDTO,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Reports<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns collaboration counts per requester-supplier company pair per calendar month
   *
   * @tags Reports
   * @name GetCollaborationByMonth
   * @summary Collaboration per month
   * @request GET:/api/admin/reports/collaboration-by-month
   * @secure
   */
  getCollaborationByMonth = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CollaborationByMonthDTO[], ErrorResponse>({
      path: `/api/admin/reports/collaboration-by-month`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads collaboration data per company pair per month as CSV
   *
   * @tags Reports
   * @name GetCollaborationByMonthCsv
   * @summary Collaboration per month CSV
   * @request GET:/api/admin/reports/collaboration-by-month/csv
   * @secure
   */
  getCollaborationByMonthCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/collaboration-by-month/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns collaboration counts per requester-supplier company pair for the given date range
   *
   * @tags Reports
   * @name GetCollaborationSummary
   * @summary Collaboration summary
   * @request GET:/api/admin/reports/collaboration-summary
   * @secure
   */
  getCollaborationSummary = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CollaborationSummaryDTO[], ErrorResponse>({
      path: `/api/admin/reports/collaboration-summary`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads collaboration summary per company pair as CSV
   *
   * @tags Reports
   * @name GetCollaborationSummaryCsv
   * @summary Collaboration summary CSV
   * @request GET:/api/admin/reports/collaboration-summary/csv
   * @secure
   */
  getCollaborationSummaryCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/collaboration-summary/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns the count of latest-version quotes per supplier company for the given date range
   *
   * @tags Reports
   * @name GetQuotesByCompany
   * @summary Quotes per company
   * @request GET:/api/admin/reports/quotes-by-company
   * @secure
   */
  getQuotesByCompany = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<QuotesByCompanyDTO[], ErrorResponse>({
      path: `/api/admin/reports/quotes-by-company`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads quote counts per company as CSV
   *
   * @tags Reports
   * @name GetQuotesByCompanyCsv
   * @summary Quotes per company CSV
   * @request GET:/api/admin/reports/quotes-by-company/csv
   * @secure
   */
  getQuotesByCompanyCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/quotes-by-company/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns the count of latest-version quotes per calendar month for the given date range
   *
   * @tags Reports
   * @name GetQuotesByMonth
   * @summary Quotes per month
   * @request GET:/api/admin/reports/quotes-by-month
   * @secure
   */
  getQuotesByMonth = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<QuotesByMonthDTO[], ErrorResponse>({
      path: `/api/admin/reports/quotes-by-month`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads quote counts per month as CSV
   *
   * @tags Reports
   * @name GetQuotesByMonthCsv
   * @summary Quotes per month CSV
   * @request GET:/api/admin/reports/quotes-by-month/csv
   * @secure
   */
  getQuotesByMonthCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/quotes-by-month/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns detail rows for all latest-version quotes in the given date range
   *
   * @tags Reports
   * @name GetQuotesDetail
   * @summary Quote detail rows
   * @request GET:/api/admin/reports/quotes-detail
   * @secure
   */
  getQuotesDetail = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<QuoteDetailDTO[], ErrorResponse>({
      path: `/api/admin/reports/quotes-detail`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads quote detail rows as CSV
   *
   * @tags Reports
   * @name GetQuotesDetailCsv
   * @summary Quote detail rows CSV
   * @request GET:/api/admin/reports/quotes-detail/csv
   * @secure
   */
  getQuotesDetailCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/quotes-detail/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns latest-version quote counts grouped by supplier company and status (pivot) for the given date range
   *
   * @tags Reports
   * @name GetQuoteStatusByCompany
   * @summary Quote status per company
   * @request GET:/api/admin/reports/quote-status-by-company
   * @secure
   */
  getQuoteStatusByCompany = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<QuoteStatusByCompanyDTO[], ErrorResponse>({
      path: `/api/admin/reports/quote-status-by-company`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads quote status pivot data per company as CSV
   *
   * @tags Reports
   * @name GetQuoteStatusByCompanyCsv
   * @summary Quote status per company CSV
   * @request GET:/api/admin/reports/quote-status-by-company/csv
   * @secure
   */
  getQuoteStatusByCompanyCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/quote-status-by-company/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns supplier-requester relationship rows for latest-version quotes in the given date range
   *
   * @tags Reports
   * @name GetQuoteSupplierRequester
   * @summary Supplier-requester rows
   * @request GET:/api/admin/reports/supplier-requester
   * @secure
   */
  getQuoteSupplierRequester = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<QuoteSupplierRequesterDTO[], ErrorResponse>({
      path: `/api/admin/reports/supplier-requester`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads supplier-requester relationship rows as CSV
   *
   * @tags Reports
   * @name GetQuoteSupplierRequesterCsv
   * @summary Supplier-requester rows CSV
   * @request GET:/api/admin/reports/supplier-requester/csv
   * @secure
   */
  getQuoteSupplierRequesterCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/supplier-requester/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns the count of requests per requester company for the given date range
   *
   * @tags Reports
   * @name GetRequestsByCompany
   * @summary Requests per company
   * @request GET:/api/admin/reports/requests-by-company
   * @secure
   */
  getRequestsByCompany = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestsByCompanyDTO[], ErrorResponse>({
      path: `/api/admin/reports/requests-by-company`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads request counts per company as CSV
   *
   * @tags Reports
   * @name GetRequestsByCompanyCsv
   * @summary Requests per company CSV
   * @request GET:/api/admin/reports/requests-by-company/csv
   * @secure
   */
  getRequestsByCompanyCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/requests-by-company/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns the count of requests per calendar month for the given date range
   *
   * @tags Reports
   * @name GetRequestsByMonth
   * @summary Requests per month
   * @request GET:/api/admin/reports/requests-by-month
   * @secure
   */
  getRequestsByMonth = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestsByMonthDTO[], ErrorResponse>({
      path: `/api/admin/reports/requests-by-month`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads request counts per month as CSV
   *
   * @tags Reports
   * @name GetRequestsByMonthCsv
   * @summary Requests per month CSV
   * @request GET:/api/admin/reports/requests-by-month/csv
   * @secure
   */
  getRequestsByMonthCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/requests-by-month/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns detail rows for all requests in the given date range
   *
   * @tags Reports
   * @name GetRequestsDetail
   * @summary Request detail rows
   * @request GET:/api/admin/reports/requests-detail
   * @secure
   */
  getRequestsDetail = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestDetailDTO[], ErrorResponse>({
      path: `/api/admin/reports/requests-detail`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads request detail rows as CSV
   *
   * @tags Reports
   * @name GetRequestsDetailCsv
   * @summary Request detail rows CSV
   * @request GET:/api/admin/reports/requests-detail/csv
   * @secure
   */
  getRequestsDetailCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/requests-detail/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Returns request counts grouped by company and status (pivot) for the given date range
   *
   * @tags Reports
   * @name GetRequestStatusByCompany
   * @summary Request status per company
   * @request GET:/api/admin/reports/request-status-by-company
   * @secure
   */
  getRequestStatusByCompany = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RequestStatusByCompanyDTO[], ErrorResponse>({
      path: `/api/admin/reports/request-status-by-company`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Downloads request status pivot data per company as CSV
   *
   * @tags Reports
   * @name GetRequestStatusByCompanyCsv
   * @summary Request status per company CSV
   * @request GET:/api/admin/reports/request-status-by-company/csv
   * @secure
   */
  getRequestStatusByCompanyCsv = (
    query?: {
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ErrorResponse>({
      path: `/api/admin/reports/request-status-by-company/csv`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
}
